import * as React from 'react';
import Switch from 'react-switch';
import WizardCard from '../../components/WizardCard/WizardCard';
import { beautyServices, otherServices } from './ServicesStaticData';
import withContainer from '../../containers/WithContainer';
import Appear from '../../components/Appear/Appear';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';

interface ServicesState {
  selectedServices: string[];
  isOthersShowing: boolean;
}

class Services extends React.Component<any, ServicesState> {
  constructor(props) {
    super(props);
    this.state = {
      selectedServices: [],
      isOthersShowing: false,
    };
  }
  app = this.props.appContainer;

  handleSelection = option => {
    let selectedServices = this.state.selectedServices;
    if (selectedServices.includes(option)) {
      selectedServices = [
        ...selectedServices.filter(service => service !== option),
      ];
    } else {
      selectedServices = [...selectedServices, option];
    }
    this.setState({ selectedServices });
  };

  handleOthers = () => {
    this.setState({ isOthersShowing: !this.state.isOthersShowing });
  };

  onNext = () => {
    this.props.appContainer.step3update(this.getCurrStep());
  };

  getCurrStep = () => {
    let step = parseInt(this.props.match.path.split('-')[1]);
    return step;
  };
  render() {
    const { selectedServices } = this.state;
    return (
      <WizardCard
        title="What services do you offer?"
        subTitle=""
        delay={1.5}
        onNext={this.onNext}
      >
        <Appear delay={1.5}>
          <div className="columns is-multiline is-capitalized">
            <div className="column has-padding-5 is-full">
              {/*  <div className="title is-5 has-margin-bottom-5">
                Beauty
              </div> */}
            </div>
            {beautyServices.map(({ label, value }) => (
              <div
                className="column has-padding-top-10 has-padding-bottom-10 is-full has-cursor-pointer"
                key={value}
              >
                <div
                  className="level is-mobile"
                  onClick={() => this.handleSelection(value)}
                >
                  <div className="level-left">
                    <div className="level-item">{label}</div>
                  </div>
                  <div className="level-right">
                    <div className="level-item">
                      <Switch
                        height={24}
                        width={45}
                        onColor="#00d1b2"
                        checkedIcon={false}
                        uncheckedIcon={false}
                        checked={this.app.state.step3[value] || false}
                        onChange={() => this.app.handleStep3Switch(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {/* <div className="column has-padding-5 has-margin-top-15 is-full has-cursor-pointer">
              <div
                className="has-margin-bottom-5"
                onClick={this.handleOthers}
              >
                <span className="title is-5">
                  Others&nbsp;
                </span>
                {
                  !this.state.isOthersShowing &&
                  <span>
                    <i className="fas fa-angle-right"></i>
                  </span>
                }
                {
                  this.state.isOthersShowing &&
                  <span>
                    <i className="fas fa-angle-right fa-rotate-90"></i>
                  </span>
                }
              </div>
            </div> */}
            {this.state.isOthersShowing && (
              <div className="column is-full">
                <div className="columns has-border-top is-full is-multiline">
                  <Appear className="is-full-width">
                    {otherServices.map(({ label, value }) => (
                      <div
                        className="column has-padding-top-5 has-padding-bottom-5 is-full has-cursor-pointer is-full"
                        key={value}
                      >
                        <div
                          className="level is-mobile"
                          onClick={() => this.handleSelection(value)}
                        >
                          <div className="level-left">
                            <div className="level-item">{label}</div>
                          </div>
                          <div className="level-right">
                            <div className="level-item">
                              <Switch
                                height={24}
                                width={45}
                                onColor="#00d1b2"
                                checkedIcon={false}
                                uncheckedIcon={false}
                                checked={selectedServices.includes(value)}
                                onChange={() =>
                                  this.app.handleStep3Switch(value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Appear>
                </div>
              </div>
            )}
          </div>
        </Appear>
      </WizardCard>
    );
  }
}

export default withRouter(withContainer(Services));
